import React from "react";

export function Wordmark({ className = "", light = false }) {
  return (
    <span className={`font-head font-extrabold tracking-tight ${light ? "text-white" : "text-foreground"} ${className}`} data-testid="wordmark">
      Airfistuus<sup className="ml-0.5 align-super text-[0.45em] font-bold opacity-70">TM</sup>
    </span>
  );
}
